import React from "react";
import { withRouter } from "react-router-dom";
import { Navbar, Nav } from "react-bootstrap";
import { Link, NavLink } from "react-router-dom";

import "./SideNavbar.css";
import { toast } from "react-toastify";
import i18n from "i18next";
import {Trans} from "react-i18next";

interface MyProps {
  user: any;
}

interface MyState {
  isMobileMenuOpen: boolean;
}

class SideNavbar extends React.Component<MyProps, MyState> {
  constructor(props) {
    super(props);
    this.state = {
      isMobileMenuOpen: false
    };
    this.toggleMobileMenu = this.toggleMobileMenu.bind(this);
    this.closeMobileMenu = this.closeMobileMenu.bind(this);
  }

  toggleMobileMenu() {
    this.setState({ isMobileMenuOpen: !this.state.isMobileMenuOpen });
  }

  closeMobileMenu() {
    this.setState({ isMobileMenuOpen: false });
  }

  render() {
    var labelStyle = {
      color: "#CCCCCC",
    };

    const { user } = this.props;
    const { isMobileMenuOpen } = this.state;


    let licenseType = 0;
    if (user && user.LicenseType) {
      licenseType = user.LicenseType;
    }
    const isMobile = window.innerWidth < 768;

    return (
      <div className="side-bar-parent">
        {/* Bouton hamburger mobile */}
        <button 
          className="mobile-menu-toggle" 
          onClick={this.toggleMobileMenu}
          aria-label="Toggle menu"
        >
          <i className="fas fa-bars"></i>
        </button>

        {/* Overlay pour fermer le menu en cliquant à côté */}
        {isMobileMenuOpen && (
          <div 
            className="mobile-menu-overlay" 
            onClick={this.closeMobileMenu}
          ></div>
        )}

        <div id="sidebar-menu" className={isMobileMenuOpen ? 'mobile-open' : ''}>
          <div className="logo-container">
            <img src="assets/images/logo.png" alt="Avatar woman" />
          </div>

          {/* Bouton fermer dans le menu mobile */}
          <button 
            className="mobile-menu-close" 
            onClick={this.closeMobileMenu}
            aria-label="Close menu"
          >
            <i className="fas fa-times"></i>
          </button>

          <Nav className="side-nav-container">
            {user && user.AuthToken && (user.Type == 2 || user.Type == 1) && (
              <Navbar.Text>
                &nbsp;&nbsp;
                <NavLink
                  to="/home"
                  activeClassName="selected"
                  className="normal btn-block"
                  onClick={this.closeMobileMenu}
                >
                  <i className="fas fa-home"></i>
                  <Trans>
                    trans_33_menu_home
                  </Trans>
                </NavLink>
                
                {/* MyVox - masqué en mobile */}
                <NavLink
                    to="/myvox"
                    activeClassName={licenseType == 0 ? "" : "selected"}
                    className={`normal btn-block mobile-hidden ${licenseType == 0 ? "disabled-link" : ""}`}
                    onClick={(e) => {
                      if(licenseType == 0){
                        e.preventDefault();
                        toast.warn(i18n.t("trans_33_page_blocked_upgrade_license"));
                      } else {
                        this.closeMobileMenu();
                      }
                    }}
                >
                  <i className="fas fa-vote-yea"></i>
                  <Trans>
                    trans_33_menu_my_vox
                  </Trans>
                </NavLink>
                
                {/* Campaign - accessible en mobile */}
                <NavLink
                  to="/campaign"
                  activeClassName={licenseType == 0 ? "" : "selected"}
                    className={`normal btn-block ${licenseType == 0 ? "disabled-link" : ""}`}
                    onClick={(e) => {
                      if(licenseType == 0){
                        e.preventDefault();
                        toast.warn(i18n.t("trans_33_page_blocked_upgrade_license"));
                      } else {
                        this.closeMobileMenu();
                      }
                    }}
                >
                  <i className="far fa-map"></i>
                  <Trans>
                    trans_33_menu_campaign
                  </Trans>
                </NavLink>

                {/* Scan - masqué en mobile */}
                <NavLink
                    to="/scan"
                    activeClassName="selected"
                    className="normal btn-block mobile-hidden"
                    onClick={this.closeMobileMenu}
                >
                  <i className="fab fa-creative-commons-sampling"></i>
                  <Trans>
                    trans_33_menu_scan
                  </Trans>
                </NavLink>

                {/* Pulse - masqué en mobile */}
                <NavLink
                    to="/pulse"
                    activeClassName={(licenseType == 0 || licenseType == 1)? "" : "selected"}
                    className={`normal btn-block mobile-hidden ${(licenseType == 0 || licenseType == 1) ? "disabled-link" : ""}`}
                    onClick={(e) => {
                      if((licenseType == 0 || licenseType == 1)){
                        e.preventDefault();
                        toast.warn(i18n.t("trans_33_page_blocked_upgrade_license"));
                      } else {
                        this.closeMobileMenu();
                      }
                    }}
                >
                  <i className="fas fa-bolt"></i>
                  <Trans>
                    trans_33_menu_pulse
                  </Trans>
                </NavLink>

                {/* Request/Crowdsource - masqué en mobile */}
                <NavLink
                    to="/request"
                    activeClassName={(licenseType == 0 || licenseType == 1) ? "" : "selected"}
                    className={`normal btn-block mobile-hidden ${(licenseType == 0 || licenseType == 1) ? "disabled-link" : ""}`}
                    onClick={(e) => {
                      if((licenseType == 0 || licenseType == 1)){
                        e.preventDefault();
                        toast.warn(i18n.t("trans_33_page_blocked_upgrade_license"));
                      } else {
                        this.closeMobileMenu();
                      }
                    }}
                >
                  <i className="fas fa-question"></i>
                  <Trans>
                    trans_33_menu_request
                  </Trans>
                </NavLink>

                {/* Results - accessible en mobile */}
                <NavLink
                  to="/results"
                  activeClassName="selected"
                  className="normal btn-block"
                  onClick={this.closeMobileMenu}
                >
                  <i className="fas fa-poll-h"></i>
                  <Trans>
                    trans_33_menu_results
                  </Trans>
                </NavLink>

                {/* Advices - masqué en mobile */}
                <NavLink
                    to="/advices"
                    activeClassName={licenseType == 0 ? "" : "selected"}
                    className={`normal btn-block mobile-hidden ${licenseType == 0 ? "disabled-link" : ""}`}
                    onClick={(e) => {
                      if(licenseType == 0){
                        e.preventDefault();
                        toast.warn(i18n.t("trans_33_page_blocked_upgrade_license"));
                      } else {
                        this.closeMobileMenu();
                      }
                    }}
                >
                  <i className="fas fa-book"></i>
                  <Trans>
                    trans_33_menu_advice
                  </Trans>
                </NavLink>

                {/* Settings - TOUJOURS visible (desktop ET mobile) */}
                {user && user.AuthToken && (user.IdCompany != 69 && user.IdCompany != 71 && user.IdCompany != 129) &&
                    <NavLink
                        to="/settings"
                        activeClassName="selected"
                        className="normal btn-block"
                        onClick={this.closeMobileMenu}
                    >
                      <i className="fas fa-cogs"></i>
                      <Trans>
                        trans_33_menu_settings
                      </Trans>
                    </NavLink>
                }

              </Navbar.Text>
            )}

            {/* ✅ Admin Panel - visible mobile + desktop pour admins */}
            {user && user.AuthToken && user.Type == 1 && (
              <Navbar.Text>
                &nbsp;&nbsp;
                <div className="admin-title">
                  <p>Admin Panel</p>
                </div>
                
                {/* Desktop uniquement - pages complexes */}
                <NavLink
                  to="/adminusers"
                  activeClassName="selected"
                  className="normal btn-block mobile-hidden"
                  onClick={this.closeMobileMenu}
                >
                  <i className="fas fa-users"></i>
                  <Trans>
                    trans_33_menu_users
                  </Trans>
                </NavLink>
                <NavLink
                  to="/admincompanies"
                  activeClassName="selected"
                  className="normal btn-block mobile-hidden"
                  onClick={this.closeMobileMenu}
                >
                  <i className="fas fa-building"></i>
                  <Trans>
                    trans_33_menu_companies
                  </Trans>
                </NavLink>
                <NavLink
                  to="/adminquestions"
                  activeClassName="selected"
                  className="normal btn-block mobile-hidden"
                  onClick={this.closeMobileMenu}
                >
                  <i className="fas fa-question-circle"></i>
                  <Trans>
                    trans_33_menu_questions
                  </Trans>
                </NavLink>
                <NavLink
                  to="/adminresources"
                  activeClassName="selected"
                  className="normal btn-block mobile-hidden"
                  onClick={this.closeMobileMenu}
                >
                  <i className="fas fa-file-alt"></i>
                  <Trans>
                    trans_33_menu_resources
                  </Trans>
                </NavLink>
                <NavLink
                  to="/adminlicenses"
                  activeClassName="selected"
                  className="normal btn-block mobile-hidden"
                  onClick={this.closeMobileMenu}
                >
                  <i className="fas fa-key"></i>
                  <Trans>
                    trans_33_menu_licenses
                  </Trans>
                </NavLink>
                <NavLink
                  to="/adminresults"
                  activeClassName="selected"
                  className="normal btn-block mobile-hidden"
                  onClick={this.closeMobileMenu}
                >
                  <i className="fas fa-poll-h"></i>
                  <Trans>
                    trans_33_menu_results
                  </Trans>
                </NavLink>
                <NavLink
                  to="/adminanswers"
                  activeClassName="selected"
                  className="normal btn-block mobile-hidden"
                  onClick={this.closeMobileMenu}
                >
                  <i className="fas fa-comment"></i>
                  <Trans>
                    trans_33_menu_answers
                  </Trans>
                </NavLink>
                
                {/* ✅ VOX Monitor - visible mobile ET desktop */}
                <NavLink
                  to="/showAllVoxes"
                  activeClassName="selected"
                  className="normal btn-block"
                  onClick={this.closeMobileMenu}
                >
                  <i className="fas fa-tablet-alt"></i>
                  VOX Monitor
                </NavLink>
                
                {/* Desktop uniquement - Logs */}
                <NavLink
                  to="/adminlogs"
                  activeClassName="selected"
                  className="normal btn-block mobile-hidden"
                  onClick={this.closeMobileMenu}
                >
                  <i className="fas fa-list"></i>
                  <Trans>
                    trans_33_menu_logs
                  </Trans>
                </NavLink>
              </Navbar.Text>
            )}
          </Nav>
        </div>
      </div>
    );
  }
}

export default withRouter(SideNavbar);